export enum SectionEventType {
  SECTION_OPENED = 'section_opened',
  SECTION_COMPLETED = 'section_completed',
}
